import React from 'react';
import useStyle from './cartButton.style';
import { classNames } from 'helpers/style/classNames';
import pages from 'routes/pages';
import { Location } from 'history';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';

export interface CartButtonViewProps {
  onClick: () => void;
  numberOfArticles?: number;
  helpText?: string;
  isMobile: boolean;
  location?: Location;
}

export const CartButtonView = ({
  onClick,
  numberOfArticles,
  helpText,
  isMobile,
  location = null
}: CartButtonViewProps) => {
  const classes = useStyle();

  return (
    <button
      onClick={onClick}
      className={classNames(
        [classes.root],
        [
          {
            condition: isMobile,
            classe: classes.mobile
          },
          {
            condition: numberOfArticles > 0,
            classe: classes.green
          },
          {
            condition: isMobile && location.pathname === pages.PANIER_PAGE.path,
            classe: classes.active
          },
          {
            condition: !isMobile,
            classe: classes.desktop
          }
        ]
      )}
    >
      {numberOfArticles > 0 && (
        <span
          className={classNames(
            [],
            [
              { condition: !isMobile, classe: classes.articles },
              { condition: isMobile, classe: classes.articlesMobile }
            ]
          )}
        >
          {numberOfArticles}
        </span>
      )}
      <FlatIcon icon={'ShoppingCart'} color={!isMobile && '#000000'} />
      {helpText && (
        <div className={classes.desc}>
          <span>{helpText}</span>
        </div>
      )}
    </button>
  );
};
